export default __webpack_public_path__ + "static/media/subscription@2x.1b90cfdc.png";